// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__NISGI","disabled":"FileBtn_disabled__3TYb9","warn":"FileBtn_warn__2EJ7I","fade":"FileBtn_fade__2ZN58"};